/* v2.9.5 - Galeri paneli mega menu davranisi: 80ms hover-intent, Esc,
   dis tiklama, aria-expanded. Klavye: odak panele girince acik kalir. */
(function () {
  'use strict';
  function init(root) {
    var nav = (root || document).querySelector('.gnav');
    if (!nav || nav.__gnavBound) return;
    nav.__gnavBound = true;
    var items = nav.querySelectorAll('.gnav__item--has-panel');
    var openItem = null;
    var timer = null;

    function setOpen(item, open) {
      if (!item) return;
      item.classList.toggle('is-open', open);
      var link = item.querySelector('.gnav__link');
      if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        if (openItem && openItem !== item) setOpen(openItem, false);
        openItem = item;
      } else if (openItem === item) {
        openItem = null;
      }
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { setOpen(item, true); }, 80);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { setOpen(item, false); }, 140);
      });
      var link = item.querySelector('.gnav__link');
      if (link) {
        link.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === ' ') {
            if (!item.classList.contains('is-open')) { e.preventDefault(); setOpen(item, true); }
          }
        });
      }
      item.addEventListener('focusout', function () {
        requestAnimationFrame(function () {
          if (!item.contains(document.activeElement)) setOpen(item, false);
        });
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openItem) {
        var l = openItem.querySelector('.gnav__link');
        setOpen(openItem, false);
        if (l) l.focus();
      }
    });
    document.addEventListener('click', function (e) {
      if (openItem && !nav.contains(e.target)) setOpen(openItem, false);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
